/**
 * AppFooter Component
 *
 * Simple footer inside the main content area.
 */
import { makeStyles, tokens, Caption1 } from '@fluentui/react-components';

const useStyles = makeStyles({
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalXXL}`,
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
    color: tokens.colorNeutralForeground3,
    flexShrink: 0,
  },
});

export function AppFooter() {
  const styles = useStyles();
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <Caption1>LeftShield Runtime Governance Platform &copy; {year} LeftShield</Caption1>
    </footer>
  );
}
